module.exports = __webpack_public_path__ + "assets/img/3.87eb0dd1.png";